// extracted by mini-css-extract-plugin
export default {"bannerArea":"Banner_bannerArea__PTZwy","bannerImage":"Banner_bannerImage__Q19x8"};